// source: client/frontend/web/poc/purchase_client.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

var imports_ecom_country_code_pb =
    require('../../../../imports/ecom/country_code_pb.js');
goog.object.extend(proto, imports_ecom_country_code_pb);
var imports_ecom_currency_code_pb =
    require('../../../../imports/ecom/currency_code_pb.js');
goog.object.extend(proto, imports_ecom_currency_code_pb);
var imports_ecom_payment_info_pb =
    require('../../../../imports/ecom/payment_info_pb.js');
goog.object.extend(proto, imports_ecom_payment_info_pb);
var imports_options_event_metadata_pb =
    require('../../../../imports/options/event_metadata_pb.js');
goog.object.extend(proto, imports_options_event_metadata_pb);
var imports_purchase_product_info_pb =
    require('../../../../imports/purchase/product_info_pb.js');
goog.object.extend(proto, imports_purchase_product_info_pb);
goog.exportSymbol('proto.com.chegg.rio.poc.PurchaseClient', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.chegg.rio.poc.PurchaseClient = function(opt_data) {
  jspb.Message.initialize(
      this, opt_data, 0, -1,
      proto.com.chegg.rio.poc.PurchaseClient.repeatedFields_, null);
};
goog.inherits(proto.com.chegg.rio.poc.PurchaseClient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.chegg.rio.poc.PurchaseClient.displayName =
      'proto.com.chegg.rio.poc.PurchaseClient';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.chegg.rio.poc.PurchaseClient.repeatedFields_ = [215, 216];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.chegg.rio.poc.PurchaseClient.prototype.toObject = function(
      opt_includeInstance) {
    return proto.com.chegg.rio.poc.PurchaseClient.toObject(
        opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.chegg.rio.poc.PurchaseClient} msg The msg instance to
   *     transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.chegg.rio.poc.PurchaseClient.toObject = function(
      includeInstance, msg) {
    var f, obj = {
      cartId: jspb.Message.getFieldWithDefault(msg, 200, ''),
      billingCity: jspb.Message.getFieldWithDefault(msg, 201, ''),
      billingCountry: jspb.Message.getFieldWithDefault(msg, 202, 0),
      billingAddressLine1: jspb.Message.getFieldWithDefault(msg, 203, ''),
      billingAddressLine2: jspb.Message.getFieldWithDefault(msg, 204, ''),
      firstName: jspb.Message.getFieldWithDefault(msg, 205, ''),
      lastName: jspb.Message.getFieldWithDefault(msg, 206, ''),
      billingPostalCode: jspb.Message.getFieldWithDefault(msg, 207, ''),
      billingState: jspb.Message.getFieldWithDefault(msg, 208, ''),
      couponCode: jspb.Message.getFieldWithDefault(msg, 209, ''),
      currencyCode: jspb.Message.getFieldWithDefault(msg, 211, 0),
      paymentMethodsList:
          (f = jspb.Message.getRepeatedField(msg, 215)) == null ? undefined : f,
      productsList: jspb.Message.toObjectList(
          msg.getProductsList(),
          imports_purchase_product_info_pb.ProductInfo.toObject,
          includeInstance),
      transactionId: jspb.Message.getFieldWithDefault(msg, 217, ''),
      taxAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 218, 0.0),
      subtotalAmount:
          jspb.Message.getFloatingPointFieldWithDefault(msg, 219, 0.0),
      totalAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 220, 0.0),
      couponDiscountValue:
          jspb.Message.getFloatingPointFieldWithDefault(msg, 221, 0.0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.chegg.rio.poc.PurchaseClient}
 */
proto.com.chegg.rio.poc.PurchaseClient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.chegg.rio.poc.PurchaseClient;
  return proto.com.chegg.rio.poc.PurchaseClient.deserializeBinaryFromReader(
      msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.chegg.rio.poc.PurchaseClient} msg The message object to
 *     deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.chegg.rio.poc.PurchaseClient}
 */
proto.com.chegg.rio.poc.PurchaseClient.deserializeBinaryFromReader = function(
    msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 200:
        var value = /** @type {string} */ (reader.readString());
        msg.setCartId(value);
        break;
      case 201:
        var value = /** @type {string} */ (reader.readString());
        msg.setBillingCity(value);
        break;
      case 202:
        var value =
            /** @type {!proto.com.chegg.rio.backend.ecom.CountryCode} */ (
                reader.readEnum());
        msg.setBillingCountry(value);
        break;
      case 203:
        var value = /** @type {string} */ (reader.readString());
        msg.setBillingAddressLine1(value);
        break;
      case 204:
        var value = /** @type {string} */ (reader.readString());
        msg.setBillingAddressLine2(value);
        break;
      case 205:
        var value = /** @type {string} */ (reader.readString());
        msg.setFirstName(value);
        break;
      case 206:
        var value = /** @type {string} */ (reader.readString());
        msg.setLastName(value);
        break;
      case 207:
        var value = /** @type {string} */ (reader.readString());
        msg.setBillingPostalCode(value);
        break;
      case 208:
        var value = /** @type {string} */ (reader.readString());
        msg.setBillingState(value);
        break;
      case 209:
        var value = /** @type {string} */ (reader.readString());
        msg.setCouponCode(value);
        break;
      case 211:
        var value =
            /** @type {!proto.com.chegg.rio.backend.ecom.CurrencyCode} */ (
                reader.readEnum());
        msg.setCurrencyCode(value);
        break;
      case 215:
        var values = /**
                        @type {!Array<!proto.com.chegg.rio.backend.ecom.PaymentMethod>}
                          */
            (reader.isDelimited() ? reader.readPackedEnum() :
                                    [reader.readEnum()]);
        for (var i = 0; i < values.length; i++) {
          msg.addPaymentMethods(values[i]);
        }
        break;
      case 216:
        var value = new imports_purchase_product_info_pb.ProductInfo;
        reader.readMessage(
            value,
            imports_purchase_product_info_pb.ProductInfo
                .deserializeBinaryFromReader);
        msg.addProducts(value);
        break;
      case 217:
        var value = /** @type {string} */ (reader.readString());
        msg.setTransactionId(value);
        break;
      case 218:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setTaxAmount(value);
        break;
      case 219:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setSubtotalAmount(value);
        break;
      case 220:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setTotalAmount(value);
        break;
      case 221:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setCouponDiscountValue(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.chegg.rio.poc.PurchaseClient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.chegg.rio.poc.PurchaseClient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.chegg.rio.poc.PurchaseClient.serializeBinaryToWriter = function(
    message, writer) {
  var f = undefined;
  f = message.getCartId();
  if (f.length > 0) {
    writer.writeString(200, f);
  }
  f = message.getBillingCity();
  if (f.length > 0) {
    writer.writeString(201, f);
  }
  f = message.getBillingCountry();
  if (f !== 0.0) {
    writer.writeEnum(202, f);
  }
  f = message.getBillingAddressLine1();
  if (f.length > 0) {
    writer.writeString(203, f);
  }
  f = message.getBillingAddressLine2();
  if (f.length > 0) {
    writer.writeString(204, f);
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(205, f);
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(206, f);
  }
  f = message.getBillingPostalCode();
  if (f.length > 0) {
    writer.writeString(207, f);
  }
  f = message.getBillingState();
  if (f.length > 0) {
    writer.writeString(208, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 209));
  if (f != null) {
    writer.writeString(209, f);
  }
  f = /** @type {!proto.com.chegg.rio.backend.ecom.CurrencyCode} */ (
      jspb.Message.getField(message, 211));
  if (f != null) {
    writer.writeEnum(211, f);
  }
  f = message.getPaymentMethodsList();
  if (f.length > 0) {
    writer.writePackedEnum(215, f);
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
        216, f,
        imports_purchase_product_info_pb.ProductInfo.serializeBinaryToWriter);
  }
  f = message.getTransactionId();
  if (f.length > 0) {
    writer.writeString(217, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 218));
  if (f != null) {
    writer.writeFloat(218, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 219));
  if (f != null) {
    writer.writeFloat(219, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 220));
  if (f != null) {
    writer.writeFloat(220, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 221));
  if (f != null) {
    writer.writeFloat(221, f);
  }
};


/**
 * optional string cart_id = 200;
 * @return {string}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getCartId = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 200, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setCartId = function(value) {
  return jspb.Message.setProto3StringField(this, 200, value);
};


/**
 * optional string billing_city = 201;
 * @return {string}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getBillingCity = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 201, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setBillingCity = function(
    value) {
  return jspb.Message.setProto3StringField(this, 201, value);
};


/**
 * optional com.chegg.rio.backend.ecom.CountryCode billing_country = 202;
 * @return {!proto.com.chegg.rio.backend.ecom.CountryCode}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getBillingCountry =
    function() {
  return /** @type {!proto.com.chegg.rio.backend.ecom.CountryCode} */ (
      jspb.Message.getFieldWithDefault(this, 202, 0));
};


/**
 * @param {!proto.com.chegg.rio.backend.ecom.CountryCode} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setBillingCountry = function(
    value) {
  return jspb.Message.setProto3EnumField(this, 202, value);
};


/**
 * optional string billing_address_line_1 = 203;
 * @return {string}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getBillingAddressLine1 =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 203, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setBillingAddressLine1 =
    function(value) {
  return jspb.Message.setProto3StringField(this, 203, value);
};


/**
 * optional string billing_address_line_2 = 204;
 * @return {string}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getBillingAddressLine2 =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 204, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setBillingAddressLine2 =
    function(value) {
  return jspb.Message.setProto3StringField(this, 204, value);
};


/**
 * optional string first_name = 205;
 * @return {string}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getFirstName = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 205, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setFirstName = function(
    value) {
  return jspb.Message.setProto3StringField(this, 205, value);
};


/**
 * optional string last_name = 206;
 * @return {string}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getLastName = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 206, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 206, value);
};


/**
 * optional string billing_postal_code = 207;
 * @return {string}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getBillingPostalCode =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 207, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setBillingPostalCode =
    function(value) {
  return jspb.Message.setProto3StringField(this, 207, value);
};


/**
 * optional string billing_state = 208;
 * @return {string}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getBillingState = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 208, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setBillingState = function(
    value) {
  return jspb.Message.setProto3StringField(this, 208, value);
};


/**
 * optional string coupon_code = 209;
 * @return {string}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getCouponCode = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 209, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setCouponCode = function(
    value) {
  return jspb.Message.setField(this, 209, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.clearCouponCode = function() {
  return jspb.Message.setField(this, 209, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.hasCouponCode = function() {
  return jspb.Message.getField(this, 209) != null;
};


/**
 * optional com.chegg.rio.backend.ecom.CurrencyCode currency_code = 211;
 * @return {!proto.com.chegg.rio.backend.ecom.CurrencyCode}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getCurrencyCode = function() {
  return /** @type {!proto.com.chegg.rio.backend.ecom.CurrencyCode} */ (
      jspb.Message.getFieldWithDefault(this, 211, 0));
};


/**
 * @param {!proto.com.chegg.rio.backend.ecom.CurrencyCode} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setCurrencyCode = function(
    value) {
  return jspb.Message.setField(this, 211, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.clearCurrencyCode =
    function() {
  return jspb.Message.setField(this, 211, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.hasCurrencyCode = function() {
  return jspb.Message.getField(this, 211) != null;
};


/**
 * repeated com.chegg.rio.backend.ecom.PaymentMethod payment_methods = 215;
 * @return {!Array<!proto.com.chegg.rio.backend.ecom.PaymentMethod>}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getPaymentMethodsList =
    function() {
  return /** @type {!Array<!proto.com.chegg.rio.backend.ecom.PaymentMethod>} */ (jspb.Message.getRepeatedField(this, 215));
};


/**
 * @param {!Array<!proto.com.chegg.rio.backend.ecom.PaymentMethod>} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setPaymentMethodsList =
    function(value) {
  return jspb.Message.setField(this, 215, value || []);
};


/**
 * @param {!proto.com.chegg.rio.backend.ecom.PaymentMethod} value
 * @param {number=} opt_index
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.addPaymentMethods = function(
    value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 215, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.clearPaymentMethodsList =
    function() {
  return this.setPaymentMethodsList([]);
};


/**
 * repeated com.chegg.rio.edge.purchase.ProductInfo products = 216;
 * @return {!Array<!proto.com.chegg.rio.edge.purchase.ProductInfo>}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.com.chegg.rio.edge.purchase.ProductInfo>} */ (
      jspb.Message.getRepeatedWrapperField(
          this, imports_purchase_product_info_pb.ProductInfo, 216));
};


/**
 * @param {!Array<!proto.com.chegg.rio.edge.purchase.ProductInfo>} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setProductsList = function(
    value) {
  return jspb.Message.setRepeatedWrapperField(this, 216, value);
};


/**
 * @param {!proto.com.chegg.rio.edge.purchase.ProductInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.chegg.rio.edge.purchase.ProductInfo}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.addProducts = function(
    opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(
      this, 216, opt_value, proto.com.chegg.rio.edge.purchase.ProductInfo,
      opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.clearProductsList =
    function() {
  return this.setProductsList([]);
};


/**
 * optional string transaction_id = 217;
 * @return {string}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getTransactionId = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 217, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setTransactionId = function(
    value) {
  return jspb.Message.setProto3StringField(this, 217, value);
};


/**
 * optional float tax_amount = 218;
 * @return {number}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getTaxAmount = function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 218, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setTaxAmount = function(
    value) {
  return jspb.Message.setField(this, 218, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.clearTaxAmount = function() {
  return jspb.Message.setField(this, 218, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.hasTaxAmount = function() {
  return jspb.Message.getField(this, 218) != null;
};


/**
 * optional float subtotal_amount = 219;
 * @return {number}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getSubtotalAmount =
    function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 219, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setSubtotalAmount = function(
    value) {
  return jspb.Message.setField(this, 219, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.clearSubtotalAmount =
    function() {
  return jspb.Message.setField(this, 219, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.hasSubtotalAmount =
    function() {
  return jspb.Message.getField(this, 219) != null;
};


/**
 * optional float total_amount = 220;
 * @return {number}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getTotalAmount = function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 220, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setTotalAmount = function(
    value) {
  return jspb.Message.setField(this, 220, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.clearTotalAmount = function() {
  return jspb.Message.setField(this, 220, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.hasTotalAmount = function() {
  return jspb.Message.getField(this, 220) != null;
};


/**
 * optional float coupon_discount_value = 221;
 * @return {number}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.getCouponDiscountValue =
    function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 221, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.setCouponDiscountValue =
    function(value) {
  return jspb.Message.setField(this, 221, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.poc.PurchaseClient} returns this
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.clearCouponDiscountValue =
    function() {
  return jspb.Message.setField(this, 221, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.poc.PurchaseClient.prototype.hasCouponDiscountValue =
    function() {
  return jspb.Message.getField(this, 221) != null;
};


goog.object.extend(exports, proto.com.chegg.rio.poc);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/client/frontend/web/poc/purchase_client_pb.js
// module id = 4219
// module chunks = 11